import { getObjectTypeValues } from "type/common/type_util";

export const DL_GROUP_SLUG = {
  PetarLubarda: "petar-lubarda",
  SavaSumanovic: "sava-sumanovic",
  NadezdaPetrovic: "nadezda-petrovic",
  MuzejSavremeneUmetnosti: "muzej-savremene-umetnosti",
  Avangarda: "avangarda",
  OktobarskiSalon: "oktobarski-salon",
  KonceptualnaUmetnost: "konceptualna-umetnost",
} as const;

const dlGroupSLugs = getObjectTypeValues(DL_GROUP_SLUG);

export type DlGroupSlug = (typeof dlGroupSLugs)[number];
